module.exports = __webpack_public_path__ + "img/lotto.14b8520c.png";